import {GetSeferData}   from "SeferPetach/GetData";

export async function getOrdersList(obj) {
    var payload = await GetSeferData("rf5", obj);
    return (payload);
}
export async function getOrdersByIDSet(order_ids){
    var payload = await GetSeferData("rf4", {'ORDER_ID': order_ids});
    return (payload);
}
export async function getOrderByID(order_id){
    var payload = await GetSeferData("of13", {'ORDER_ID': order_id});
    return (payload);
}
export async function getFilterMeta(){
    var payload = await GetSeferData("rfaux1", {});
    return (payload);
}
export async function getUserTag() {
    var args = {};
    var payload = await GetSeferData("usf1", args);
    return (payload);
}
export async function UpdateOrderTag(order_id, tag_id) {
    var payload = await GetSeferData("of9", {'ORDER_ID': order_id,'TAG_ID':tag_id});
    return (payload);
}
export async function RemoveTagOrdersByIDSet(tag_id, order_ids){
    var payload = await GetSeferData("of10", {'TAG_ID': tag_id,'ORDER_ID': order_ids});
    return (payload);
}